import PaymentContainerClient from "../../PaymentContainerClient";
import { PaymentMethodName } from "../../PaymentContainerClient/commons/enums";
import UpdatePaymentRequestDto from "../../PaymentContainerClient/dtos/UpdatePaymentRequestDto";
import UpdatePaymentResponseDto from "../../PaymentContainerClient/dtos/UpdatePaymentResponseDto";
import { GainsightEvent, trackEvent } from "../common/gainsight";

export const updatePayment = async (
    token: string,
    locale: string,
    paymentPlanId: string,
    installmentIds: string[],
    paymentMethod: PaymentMethodName,
    paymentId: string
): Promise<UpdatePaymentResponseDto> => {
    const paymentContainerClient = new PaymentContainerClient();

    const updatePaymentRequestDto: UpdatePaymentRequestDto = {
        installmentIds: installmentIds,
        paymentMethodName: paymentMethod,
        paymentPlanId: paymentPlanId,
        langLocale: locale,
    };

    const paymentData = await paymentContainerClient.updatePayment(
        token,
        updatePaymentRequestDto,
        paymentId
    );

    trackEvent(GainsightEvent.UpdatePayment);

    return paymentData;
};
